import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ComputeService } from "utils/services/compute.service";
import { setCurrentTableStateAC } from "store/actions/table";

import columnConverter from "../lib/column-converter";
import { getTabs } from "store/selectors/tabsSettings";

export const useTableData = ({ columnsInfo, rowsData, tableId }) => {
  const dispatch = useDispatch();

  const columns = useMemo(() => columnConverter(columnsInfo), [columnsInfo]);

  const temporaryColumnScheme = useSelector(
    (state) => state.condition.columnSchemes
  );

  const tabsSettings = useSelector(getTabs);

  const schemesForTab = useMemo(
    () => tabsSettings?.[tableId]?.columnSchemes || {},
    [tableId, tabsSettings]
  );

  const columnSchemes = useMemo(
    () => ({ ...schemesForTab, ...temporaryColumnScheme }),
    [schemesForTab, temporaryColumnScheme]
  );
  
  useEffect(() => {
    dispatch(
      setCurrentTableStateAC(
        ComputeService.executeFunctions({
          columns,
          rows: rowsData,
          columnSchemes,
        })
      )
    );
  }, [
    columnsInfo,
    columnSchemes,
    dispatch,
    columns,
    rowsData,
  ]);

  return useSelector((state) => state.table.currentTableState);
};

export default useTableData;
